<template>
<div class="container">

<div class="row bwhite user">
	<div class="col-3" style="position:relative;">
	   <img :src="avatar" :alt="name" class="avatar" v-show="avatar">
	   <i class="fa fa-vcard avatar" v-show="!avatar"></i>
	</div>
	<div class="col-7 he">
		<p class="name">{{name}}</p>
		<p class="fy">
            <hos @select="haha" :hos="hos" :change="hos_change" ititle="切换分院"></hos>	
        </p>
	</div>
</div>

<div class="row center empty" v-show="!list||list.length==0">
	<i class="fa fa-shopping-cart"></i>
	<p>暂无体检报告<br/>请检查
	<router-link to="/user/info">个人资料</router-link>
	是否填写正确<br/>若有疑问，请致电：400-1111-300</p>
</div>

<div class="row first myitem" v-if="list.length>0">
	<div class="col-8" style="padding-left:.5rem;"  @click="goo(list[0])">
		<p class="title">{{list[0]['tcname']}}</p> 
        <small class="time" v-if="list[0].time">({{list[0]['time']|strtime}})</small>
		<small class="gray" v-if="!list[0].finish">制作中...</small>
	</div>
	<div class="col-2"> 
        <a :href="list[0].pdf" v-show="list[0].pdf" class="download" download>下载</a>
        <i class="fa fa-angle-right fright"  @click="goo(list[0])"></i>
    </div>
</div>

<div class="row bwhite" style="margin-top:1rem;" v-show="list.length>1">
	<div class="row">
		<h4 style="border-bottom:1px solid #ddd;color:#adadad;">体检历史纪录</h4>
	</div>
	<div class="row myitem" v-if="list.length>1&&i>0" v-for="(v,i) in list" :key="v.id">
		<div class="col-8" style="padding-left:.5rem;"  @click="goo(v)">
			 <p class="title">{{v.tcname}}</p> 
            <small class="time" v-if="v.time">({{v.time|strtime}})</small>
			<small class="gray" v-if="!v.finish">制作中...</small>
		</div>
		<div class="col-2 time">
            <!-- <a :href="v.pdf" v-show="v.pdf" class="download" download>下载</a> -->
            <i class="fa fa-angle-right fright"  @click="goo(v)"></i>
        </div>
	</div>
</div>

</div>	
</template>

<style scoped>
.user{margin-bottom:.5rem;}
.avatar{width:90px;height:90px;border-radius: 50%;position: relative;top:1.5rem;left:1rem;}	
i.avatar{font-size:4rem;position:absolute;top:2.7rem;left:1.5rem;color:rgb(0,144,255); }
.he{height:120px;}
.name{font-size: 1.3rem;margin-top: 3rem;padding-left:.3rem;}	
.container{background: rgb(251,251,251);}
.bwhite{background: white;}

.first{border-top:1px solid #ddd;}
.myitem{padding-top:.5rem;background: white;border-bottom: 1px solid #ddd;}
.myitem i{margin-left: 1rem;font-size: 1.3rem;color:#adadad;}
.myitem .time{color:#adadad;font-size:.8rem;}
.fright{float:right;margin-right:1rem;}
</style>

<script>
import hos from "../../lib/hos.vue";
export default{
    components:{hos},
	data:function(){
		return {
			list:"",
			name:"",
			avatar:"",
            hos:"",
            hos_change:1,
            old_hos:"",
            api:mydata.api+"Report/",
		}
    },
	created:function(){
		this.init();
	},
	methods:{
		init(){
			this.$emit("setTitle","体检报告纪录");
			this.name=fun.local("name")?fun.local("name"):"请登录";
            this.avatar=fun.local("avatar")?fun.local("avatar"):"";
            var hos=fun.local("hos")?fun.local("hos"):"";
            this.hos=fun.local("now_hos")?fun.local("now_hos"):hos;
            this.old_hos=this.hos;
            var _this=this;
            var data={hos:this.hos};	
		  fun.post(this.api+"get_report",data,function(d){
			  console.log(d);
		  	if(d.status==1){
                _this.list=d.info;
                // _this.get_pdf();
		  	}else{
		  		_this.$toast(d.info);
		  	}
		  })
		},
		goo(d){
			console.log(d);
           if(!d.finish){this.$toast("报告正在制作中，请过几天再试");return;}	
           if(d.url){
               location.href=d.url;
           }else{
		        this.$router.push("/user/report/detail/"+d.tjid);	
           }
        },
        haha(h){
            var data={
                hos:h,
            }
            fun.post(this.api+"change_hos",data,d=>{
                if(d.status==1){
                    this.list=d.info;
                    // this.get_pdf();
                    this.old_hos=data.hos;
                    fun.local("now_hos",data.hos)
                }else{
                    this.hos=this.old_hos;
                    this.hos_change=new Date().getTime();
                    this.$toast(d.info);
                }
            })
        },
        // get_pdf(){
        //     fun.post(this.api+"get_pdfs",d=>{
        //         console.log(d);
        //         if(d.status==0){return;}
        //         var list=this.list;
        //         for(var i=0,len=list.length;i<len;i++){
        //             for(var j=0,length=d.info.length;j<length;j++){
        //                  if(list[i].tjid==d.info[j].tjid){
        //                      list[i].pdf=d.info[j].file;
        //                      break;
        //                  }
        //              }
        //         }  
        //         this.list=[].concat(list); 
        //         fun.cache(fun.url()+fun.local("token"),list);
        //     })
        // }  
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/user/report.vue